import { useTranslation } from 'react-i18next'
import { ContentSection } from '../components/content-section'
import { OrganizationForm } from './organization-form'

export function SettingsOrganization() {
  const { t } = useTranslation('common')

  return (
    <ContentSection
      title={t('settingsOrganization.title')}
      desc={t('settingsOrganization.description')}
    >
      <OrganizationForm />
    </ContentSection>
  )
}
